<template>
    <div class="fail">
      <h1>При оплате возникла ошибка. Попробуйте <router-link :to="{ path: 'hall'}">еще раз</router-link>.</h1>
    </div>
</template>

<script>
export default {
  name: "fail"
};
</script>

<style lang="scss">
.fail {
  position: relative;
  height: 100%;
  h1 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 24px;
  }
  a {
    color: #fff;
    text-decoration: underline;
  }
}
</style>
